import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../request'
import moment from 'moment'
import _ from 'lodash'
import { RightsWrapper } from '../../components/_utils/utils'
import styles from '../Template/all/styles.less'

const TabPane = Tabs.TabPane
let accountPaymentCompanies = localStorage.getItem('company-details')?JSON.parse(localStorage.getItem('company-details')).accountPaymentCompanies:'';
@Form.create()

class AllStaffSalaryManagement extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    shiftTiming: [],
    allUsers: [],
    localUser:{},
    disableSalary:false,  
    workingDays: [{ id: "Monday", display: "Monday" }, { id: "Tuesday", display: "Tuesday" }, { id: "Wednesday", display: "Wednesday" },
    { id: "Thursday", display: "Thursday" }, { id: "Friday", display: "Friday" }, { id: "Saturday", display: "Saturday" }, { id: "Sunday", display: "Sunday" }]
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getStaffSalaryList({
        ...params,
        regExFilters: ["staffName"]
      })
      this.setState({ total: data.total })
      resolve(data)
    })
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateStaffSalaryList(values)
        } else {
          x = await Request.addStaffSalaryList(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Staff Salary Updated Successfully`
              : 'Staff Salary Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteStaffSalaryList = async data => {
    this.setState({ loading: true })
    await Request.deleteStaffSalaryList(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setStaffSalaryListData(staffSalaryId) {
    if (staffSalaryId) {
      Request.staffSalaryByID({ id: staffSalaryId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1'
            })
            let timing = doc.shiftTiming.split(' - ')
            this.props.form.setFieldsValue({  
              staffId: doc.staffId,
              staffSalary: doc.staffSalary,
              shiftTiming: doc.shiftTiming,
              workingDays: doc.workingDays
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  loadShiftTiming = async () => {
    let params = {
      results: 1000,
      count: 1000
    }
    let response = await Request.getAllShiftTimings(params)
    let shiftTiming = []
    _.each(response.data, (item) => {
      shiftTiming.push({ id: item.shiftTime, display: item.shiftTime })
    })
    this.setState({ shiftTiming: shiftTiming })
  }

  componentWillMount() {

  }

  async componentDidMount() {
    this.loadShiftTiming()
    let localUser = JSON.parse(localStorage.getItem("user"));

    let { data: allUsers } = await Request.loadDeskUser({
      results: 10000,
      active: true,
      // userBranch: localUser ? localUser.userBranch : null
    });
    this.setState({ allUsers, localUser });
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const { dispatch } = this.props
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    let accountPaymentCompaniesArray = [];
    if(accountPaymentCompanies.indexOf(',')) {
      accountPaymentCompaniesArray = accountPaymentCompanies.split(',');
    }
    const { id, workingDays, shiftTiming } = this.state;
    
    const inputTypes = {
      fields: [
        {
          label: "Staff Member",
          key: "staffId",
          type: "select",
          showSearch: true,
          required: true,
          allowClear: true,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.name,
          options: this.state.allUsers ? this.state.allUsers : {},
          onChange: (v) => {
            this.props.form.setFieldsValue({ staffId: v });
          },
        },
        {
          label: 'Staff Salary',
          key: 'staffSalary',
          required: true,
          disabled: ((this.state.localUser.isAdministrator || this.state.localUser.isFinanceAdmin) ? false : (!this.state.id ? false : true)),
        },
        {
          label:'Company',
          key:"company",
          required:true,
          type:'select',
          options:accountPaymentCompaniesArray,
          onChange: v =>{
            this.props.form.setFieldsValue({company:v})
          }
        },
        {
          label: 'Shift Timing',
          key: 'shiftTiming',
          type: 'select',
          options: shiftTiming,
          required: true,
          regExFilters:true,
          onChange: v => {
            this.props.form.setFieldsValue({ shiftTiming: v })
          }
        },
        {
          label: 'Working Days',
          key: 'workingDays',
          required: true,
          type: 'select',
          options: workingDays,
          mode: 'multiple',
          onChange: v => {
            this.props.form.setFieldsValue({ workingDays: v })
          }
        }
      ]
    };

    const columns = [
      {
        title: 'S No.',
        key: 'serialNumber',
        width: 60,
        fixed: true,
        render: (text, record, index) => {
          return (
            <span>{index + 1}</span>
          )
        }
      },
      {
        title: 'Staff Member',
        key: 'staffName',
        dataIndex:'staffId.name',
        searchTextName: 'staffName',
        regExFilters:true
      },
      {
        title:'Company',
        key:'company'
      },
      {
        title: 'Department',
        key: 'department',
        render: (text, record) => {
          return (<div>{record.staffId && record.staffId.department}</div>)
        }
      },
      {
        title: 'Staff Salary',
        key: 'staffSalary'
      },
      {
        title: 'Working Days',
        key: 'workingDays',
        render: (text, record) => (
          <span>{text}</span>
        )
      },
      {
        title: 'Shift Timing',
        key: 'shiftTiming'
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'staffSalaryManagement.edit'}>
              <Tooltip title="Edit Staff Salary">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setStaffSalaryListData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'staffSalaryManagement.delete'}>
              <Tooltip title="Delete Staff Salary">
                <Popconfirm
                  title="Are you sure delete this Staff Salary?"
                  onConfirm={() => {
                    this.deleteStaffSalaryList({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Staff Salary Management `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All List`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 100,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Staff Salary'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllStaffSalaryManagement
